import { Box, InputAdornment, TextField } from '@mui/material';
import { DEFAULT_CURRENCY, type FixedLineItemInput } from '@weft/types';
import { isNotNullOrUndefined } from '@weft/utils';
import { getCurrencySymbol } from 'apps/app/src/services/currency-symbol-mapper';
import { get, useFormContext } from 'react-hook-form';
import { useDynamicInvoice } from '../../../../dynamic-invoice-context';

export const EditFixedLineItemDialogFromContent: React.FC = () => {
  const { register, formState: { errors } } = useFormContext<FixedLineItemInput>();

  const nameRegister = register('modifiedName');
  const descriptionRegister = register('modifiedDescription');
  const priceRegister = register('price', {
    valueAsNumber: true,
  });
  const { dynamicInvoiceData } = useDynamicInvoice();

  const currency = dynamicInvoiceData.customer.settings?.currency ?? DEFAULT_CURRENCY;

  return (
    <>
      <TextField
        {...nameRegister}
        label="Product name"
        placeholder="Product name"
        size='medium'
        required
        fullWidth
        sx={{ padding: '10px' }}
        error={isNotNullOrUndefined(get(errors, nameRegister.name))}
        helperText={get(errors, nameRegister.name)?.message}
      />
      <Box sx={{
        display: 'flex',
        gap: '32px',
        padding: '10px',
      }}
      >
        <TextField
          {...descriptionRegister}
          label="Product description"
          placeholder="Product description"
          size='medium'
          fullWidth
          error={isNotNullOrUndefined(get(errors, descriptionRegister.name))}
          helperText={get(errors, descriptionRegister.name)?.message}
        />
        <TextField
          {...priceRegister}
          label="Price"
          placeholder="Price"
          type="number"
          size='medium'
          InputProps={{
            startAdornment: <InputAdornment position="start">{getCurrencySymbol(currency)}</InputAdornment>,
          }}
          error={isNotNullOrUndefined(get(errors, priceRegister.name))}
          helperText={get(errors, priceRegister.name)?.message}
        />
      </Box>
    </>
  );
}; 